// import 'babel-polyfill';
import 'babel-polyfill';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './style/reset.scss';
import VueCompositionAPI from '@vue/composition-api';
import tracking from 'visual-tracking';
// import Vant from 'vant';
import getOS from './util/getOs';
// import 'vant/lib/index.css';
// eslint-disable-next-line
// import VConsole from "vconsole";
import toast from 'vant/lib/toast';
import 'vant/lib/toast/style';

Vue.config.productionTip = false;

Vue.use(tracking, '请输入pageType');

Vue.use(VueCompositionAPI);

// const NODE_ENV = process.env.NODE_ENV;

// eslint-disable-next-line
// new VConsole();

// 挂载全局属性
Vue.prototype.$global = {
    platform: navigator.userAgent.indexOf('WUBA') > -1 ? 'app' : 'm',
    os: getOS()
};

window.____global = Vue.prototype.$global;
Vue.prototype.$toast = toast;

new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app');
